import React from "react";
import { Button, Popover, Table, message } from "antd";
import { CodeOutlined, CopyOutlined, LinkOutlined } from "@ant-design/icons";
import { startCase } from "lodash";

function DevVariablesPopover({
    devs,
    lang,
    item,
    active_slug,
    gs_overrides,
    prefill_data,
}) {
    return (
        <Popover
            trigger="click"
            title="Dev Variables"
            content={
                <div
                    style={{
                        maxHeight: "70vh",
                        overflowY: "auto",
                        margin: "0 -12px -12px -12px",
                    }}
                >
                    <Table
                        size="small"
                        pagination={false}
                        dataSource={[
                            ...Object.entries(devs).map(([k, v]) => ({
                                key: k,
                                k,
                                v:
                                    typeof v === "object"
                                        ? JSON.stringify(v, null, 2)
                                        : String(v),
                            })),
                            { key: "lang", k: "Language", v: String(lang) },
                            {
                                key: "template_id",
                                k: "Template ID",
                                v: String(item?.id || ""),
                            },
                            {
                                key: "active_slug",
                                k: "Active Slug",
                                v: String(active_slug || ""),
                            },
                            {
                                key: "GS Overrides",
                                k: "GS Overrides",
                                v: JSON.stringify(gs_overrides, null, 2),
                            },
                            {
                                key: "prefill_data",
                                k: "Prefill Data",
                                v: JSON.stringify(prefill_data, null, 2),
                            },
                        ]}
                        columns={[
                            {
                                title: "Key",
                                dataIndex: "k",
                                key: "k",
                                render: (text) => startCase(text),
                            },
                            {
                                title: "Value",
                                dataIndex: "v",
                                key: "v",
                                width: 400,
                                render: (text) => (
                                    <div
                                        style={{
                                            maxWidth: 400,
                                            overflowX: "auto",
                                        }}
                                    >
                                        <pre
                                            style={{
                                                margin: 0,
                                                whiteSpace: "pre",
                                            }}
                                        >
                                            {text}
                                        </pre>
                                    </div>
                                ),
                            },
                            {
                                title: "",
                                key: "copy",
                                render: (_, record) => (
                                    <Button
                                        size="small"
                                        onClick={() => {
                                            navigator.clipboard.writeText(
                                                record.v,
                                            );
                                            message.success("Copied!");
                                        }}
                                        icon={<CopyOutlined />}
                                    />
                                ),
                            },
                            {
                                title: "Link",
                                key: "link",
                                render: (_, record) => {
                                    const collectionMap = {
                                        template_id: "qp_template",
                                        entry_id: "qdb_calendar_entries",
                                        preset_id: "qp_preset_data",
                                    };
                                    const collection =
                                        collectionMap[record.key];
                                    if (!collection) return null;
                                    return (
                                        <a
                                            href={`https://api.qureal.com/admin/content/${collection}/${record.v}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <Button
                                                size="small"
                                                icon={<LinkOutlined />}
                                            />
                                        </a>
                                    );
                                },
                            },
                        ]}
                    />
                </div>
            }
        >
            <Button icon={<CodeOutlined />} />
        </Popover>
    );
}

export default DevVariablesPopover;
